module.exports = __webpack_public_path__ + "static/media/PortadaProveedor.a8210592.png";